<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">
      <el-form-item label="设备MAC地址" prop="mac">
        <el-input v-model="initForm.mac" placeholder="请输入MAC地址"></el-input>
      </el-form-item>

      <el-form-item label="AuthCode" prop="authcode">
        <el-input v-model="initForm.authcode" placeholder="请输入AuthCode"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    initForm: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        mac: [{required: true, message: "请输入设备MAC地址", trigger: "blur"}],
        authcode: [{required: true, message: "请输入AuthCode", trigger: "blur"}]
      },
      titles: {
        add: "新增设备AuthCode",
        edit: "编辑设备AuthCode"
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              mac: this.initForm.mac,
              authcode: this.initForm.authcode
            };
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "device-authcode/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "device-authcode/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
